// Ícones próprios do detalhe e do Reencontro, no mesmo traço de Icons.tsx (viewBox 24, pontas redondas, aria-hidden).
const S = (d: string, w = 1.75) => () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={w} stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);
/** Estrela de quatro pontas: etiqueta ou resumo vindos da IA. */
export const IconSpark = S("M12 3.5l1.6 4.7a3 3 0 0 0 1.9 1.9L20.2 12l-4.7 1.6a3 3 0 0 0-1.9 1.9L12 20.5l-1.6-4.7a3 3 0 0 0-1.9-1.9L3.8 12l4.7-1.6a3 3 0 0 0 1.9-1.9z", 1.5);
export const IconRedo = S("M19.5 12a7.5 7.5 0 1 1-2.2-5.3L19.5 9M19.5 4.5V9H15");
export const IconBook = S("M12 6.5C10.3 5 7.8 4.5 4 4.5v13c3.8 0 6.3.5 8 2 1.7-1.5 4.2-2 8-2v-13c-3.8 0-6.3.5-8 2zM12 6.5v13");
export const IconExpand = S("M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5");
export const IconLock = S("M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3M12 14.5v2");
export const IconArrowLeft = S("M19 12H5M11 6l-6 6 6 6", 2);
export const IconArrowRight = S("M5 12h14M13 6l6 6-6 6", 2);
export const IconText = S("M5 6.5V5h14v1.5M12 5v14M9 19h6");
// Barra de formatação (seleção no editor)
export const IconBold = S("M7.5 5H13a3.5 3.5 0 0 1 0 7H7.5zM7.5 12H14a3.5 3.5 0 0 1 0 7H7.5z", 2.25);
export const IconItalic = S("M11 5h7M6 19h7M14.5 5l-5 14", 2);
export const IconMarker = S("M4 20.5h7M8.5 16.5l-2-2L15 6a2.1 2.1 0 0 1 3 3zM6.5 14.5L5 18l3.5-1.5");
export const IconHeading = S("M6 5v14M17 5v14M6 12h11", 2);
export const IconTask = S("M5 5h14v14H5zM8.5 12.5l2.5 2.5 4.5-5.5");
export const IconQuote = S("M5 11h4v5H5zM5 11c0-3 1.5-4.5 4-5M14 11h4v5h-4zM14 11c0-3 1.5-4.5 4-5");
export const IconChain = S("M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1");
/** Capa: moldura com montanha e seta de troca. */
export const IconCover = S("M4 6h11v10H4zM4 13.5l3-3 3.5 3.5 1.5-1.5 3 3M18 9.5v8.5h-9.5M20.5 15.5l-2.5 2.5-2.5-2.5");
